const axios = require("axios");
const store = require("../../store");
const crypto = require("crypto");
const apiUrl =
  store.default.getters.getApiCredentials.baseUrl + "/CorporateAPI"; // UAT URL

const apiCall = async (inputData, file = undefined, isFileExport = false) => {
  //stage and production

  let isEncrypted = store.default.getters.getApiCredentials.isEncrypted;
  // 

  // dev
  // let isEncrypted = 0;
  let blobMethods = ["AMLPDFD", "EXCLTPLT"];

  let data = JSON.stringify(inputData);
  // if (process.env.NODE_ENV === 'production') {
  if (isEncrypted == 1) {
    data = await encrypt(data);
  }
  let requestBody = {
    isEnc: isEncrypted,
    data: data,
  };

  let config = {
    headers: {
      "Content-Type": "application/json",
    },
    responseType:
      !blobMethods.includes(inputData.method_name) && isFileExport == false
        ? "json"
        : "blob",
  };

  // console.log('FILE', file)
  if (file) {
    // console.log('FILE', "IM HERE")
    requestBody = new FormData();
    requestBody.append("data", data);
    requestBody.append("isEnc", isEncrypted);
    requestBody.append("file", file);
    config = {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    };
  }
  let response = null;
  try {

    response = await callBackendAPI(requestBody, config);
    if (response.code == '00') {
      response = response.response_body
      if (
        isEncrypted == 1 &&
        !blobMethods.includes(inputData.method_name) &&
        !isFileExport
      ) {
        response.data = JSON.parse(await decrypt(response.data));
      }
    }

  } catch (err) {
    if (err.code == 440) {
      window.location.href = "/";
    } else if (err.code == "REQERR" || err.code == "UNKERR") {
      response = err.response_body
    }
    else {
      response = err.response_body
      if (
        isEncrypted == 1 &&
        !blobMethods.includes(inputData.method_name) &&
        !isFileExport
      ) {
        response.data = JSON.parse(await decrypt(response.data));
      }
    }


  }
  return response;
};

async function callBackendAPI(requestBody, config) {
  return new Promise(function (resolve, reject) {
    axios
      .post(apiUrl, requestBody, config)
      .then((result) => {
        resolve({ code: "00", response_body: result });
      })
      .catch((err) => {

        let errorResponse = {
          data: {
            status: "ERR",
            status_msg: "ERROR",
          },
        };
        if (err.response) {
          reject({ code: err.response.status, response_body: err.response })
        } else if (err.request) {
          errorResponse.data.status = "REQERR"
          errorResponse.data.status_msg = "Unable to Process the request"
          reject({ code: "REQERR", response_body: errorResponse })
        } else {
          errorResponse.data.status = "UNKERR"
          errorResponse.data.status_msg = "Unknown error"
          reject({ code: "UNKERR", response_body: errorResponse })
        }
      });
  });
}

function encrypt(data) {
  let dataBuffer = Buffer.from(data);
  const key = crypto.randomBytes(16).toString("hex");
  const iv = crypto.randomBytes(12);
  const cipher = crypto.createCipheriv("aes-256-gcm", Buffer.from(key), iv);
  const encryptedBuffer = Buffer.concat([
    cipher.update(dataBuffer),
    cipher.final(),
  ]);
  const authTag = cipher.getAuthTag();
  let bufferLength = Buffer.alloc(1);
  bufferLength.writeUInt8(iv.length, 0);
  let encData = Buffer.concat([bufferLength, iv, authTag, encryptedBuffer]);
  let metadata =
    "02" +
    crypto.randomBytes(1).toString("hex") +
    key.length +
    crypto.randomBytes(1).toString("hex") +
    crypto.randomBytes(6).toString("hex");
  return metadata + key + encData.toString("base64");
}

function decrypt(data) {
  let metadata = data.substr(0, 20);
  let keyLength = metadata.substr(4, 2);
  let dataWithKey = data.substr(20);
  let key = dataWithKey.substr(0, keyLength);
  let encData = dataWithKey.substr(Number(keyLength));
  let keyBuffer = Buffer.from(key);
  let dataBuffer = Buffer.from(encData, "base64");
  const ivSize = dataBuffer.readUInt8(0);
  const iv = dataBuffer.slice(1, ivSize + 1);
  // The authTag is by default 16 bytes in AES-GCM
  const authTag = dataBuffer.slice(ivSize + 1, ivSize + 17);
  const decipher = crypto.createDecipheriv("aes-256-gcm", keyBuffer, iv);
  decipher.setAuthTag(authTag);
  let decData = Buffer.concat([
    decipher.update(dataBuffer.slice(ivSize + 17)),
    decipher.final(),
  ]);
  return decData.toString();
}

module.exports = {
  apiCall,
};
